export default __webpack_public_path__ + "static/media/sponsor-icon.8fd0202f.webp";